import DsvModalShell from "./DsvModalShell";
import PropTypes from 'prop-types';
import rem from "@/utils/rem.js";

function DeleteVersionModal({ visible, hide, version, onConfirm }) {
	if (!version) return null;

	return (
		<DsvModalShell
			visible={visible}
			hide={hide}
			title="Delete Draft Version"
			actions={
				<button
					className="dsv-btn dsv-btn--retire"
					style={{ marginLeft: rem(12) }}
					data-testid="confirm-delete-version-btn"
					onClick={() => onConfirm(version)}
				>
					Delete
				</button>
			}
		>
			<p className="dsv-confirm__subtitle">
				Delete draft <strong>v{version.version}</strong>? This can&apos;t be undone.
			</p>
			<p className="dsv-promote__hint">
				Only DRAFT versions can be deleted. Published versions are unaffected.
			</p>
		</DsvModalShell>
	);
}

DeleteVersionModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
	version: PropTypes.object,
	onConfirm: PropTypes.func,
};

export default DeleteVersionModal;
